// ///jacques-andre-editeur\proshop-v2\frontend\src\screens\AuthorsScreen.jsx
// import { useState, useEffect } from 'react';
// import { useParams, useNavigate } from 'react-router-dom';
// import { Form, Button, Container } from 'react-bootstrap';
// import { useGetAuthorsQuery } from '../slices/authorsApiSlice';
// import AuthorCard from '../components/AuthorCard';
// import Loader from '../components/Loader';
// import Message from '../components/Message';
// import Paginate from '../components/Paginate';
// import Meta from '../components/Meta';
// import FormContainer from '../components/FormContainer';
// import { FaSearch } from "react-icons/fa";


// const AuthorsScreen = () => {
//   const navigate = useNavigate();
//   const params = useParams();

//   // Utilisation de useState pour gérer les valeurs des paramètres
//   const [pageNumber, setPageNumber] = useState(params.pageNumber || 1);
//   const [keyword, setKeyword] = useState(params.keyword || '');
//   const [searchAuthorTerm, setSearchAuthorTerm] = useState('');

//   // Effect pour mettre à jour si params change
//   useEffect(() => {
//     setPageNumber(params.pageNumber || 1);
//     setKeyword(params.keyword || '');
//   }, [params]);

//   const parPage = 16;

//   const { data, isLoading, error } = useGetAuthorsQuery({
//     keyword,
//     pageNumber,
//     parPage
//   });

//   const submitHandler = (e) => {
//     e.preventDefault();
//     const trimmedTerm = searchAuthorTerm.trim();
//     if (trimmedTerm) {
//       navigate(`/auteurs/1/keyword/${trimmedTerm}`);
//     } else {
//       navigate('/auteurs');
//     }
//   };

//   console.log('data dans le screen AuthorsScreen.jsx : ', data)



//   return (
//     <>
//       <Meta />
//       {isLoading ? (
//         <Loader />
//       ) : error ? (
//         <Message variant='danger'>
//           {error?.data?.message || error.error}
//         </Message>
//       ) : (
//         <Container>
//           <div className="h1-container">
//             <h1>Nos auteurs</h1>
//           </div>
//             <FormContainer>
//               <Form onSubmit={submitHandler}>
//                 <div className="searchAuthor">
//                   <Form.Control
//                     type="text"
//                     placeholder="Chercher un auteur..."
//                     value={searchAuthorTerm}
//                     onChange={(e) => setSearchAuthorTerm(e.target.value)}
//                   />
//                   <Button type='submit' variant='primary' className='btn btn-primary light'><FaSearch /></Button>
//                 </div>
//               </Form>
//             </FormContainer>
//           <div className="author-row">
//             {data?.authors?.map((author) => (
//               <div className="author-card" key={author._id}>
//                 <AuthorCard author={author} />
//               </div>
//             ))}
//           </div>
//           <Paginate pages={data.pages} page={data.page} basePath="/auteurs" />
//         </Container>
//       )}
//     </>
//   );
// };

// export default AuthorsScreen;






import { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Form, Button, Container } from 'react-bootstrap';
import { FaSearch } from 'react-icons/fa';
import { useGetAuthorsQuery } from '../slices/authorsApiSlice';
import AuthorCard from '../components/AuthorCard';
import Loader from '../components/Loader';
import Message from '../components/Message';
import Paginate from '../components/Paginate';
import Meta from '../components/Meta';
import FormContainer from '../components/FormContainer';

const AuthorsScreen = () => {
  const navigate = useNavigate();
  const params = useParams();

  const pageNumber = Number(params.pageNumber) || 1;
  const keyword = params.keyword || '';

  const [searchAuthorTerm, setSearchAuthorTerm] = useState(keyword);

  const parPage = 16;

  const { data, isLoading, error } = useGetAuthorsQuery({
    keyword,
    pageNumber,
    parPage,
  });

  const submitHandler = (e) => {
    e.preventDefault();
    const trimmedTerm = searchAuthorTerm.trim();
    if (trimmedTerm) {
      navigate(`/auteurs/${trimmedTerm}/page/1`);
    } else {
      navigate('/auteurs');
    }
  };

  return (
    <>
      <Meta />
      {isLoading ? (
        <Loader />
      ) : error ? (
        <Message variant="danger">
          {error?.data?.message || error.error}
        </Message>
      ) : (
        <Container>
          <div className="h1-container">
            <h1>Nos auteurs</h1>
          </div>

          <FormContainer>
            <Form onSubmit={submitHandler}>
              <div className="searchAuthor">
                <Form.Control
                  type="text"
                  placeholder="Chercher un auteur..."
                  value={searchAuthorTerm}
                  onChange={(e) => setSearchAuthorTerm(e.target.value)}
                />
                <Button type="submit" variant="primary" className="btn btn-primary light">
                  <FaSearch />
                </Button>
              </div>
            </Form>
          </FormContainer>

          <div className="author-row">
            {data?.authors?.map((author) => (
              <div className="author-card" key={author._id}>
                <AuthorCard author={author} />
              </div>
            ))}
          </div>

          <Paginate
            pages={data.pages}
            page={data.page}
            keyword={keyword}
            basePath="/auteurs"
          />
        </Container>
      )}
    </>
  );
};

export default AuthorsScreen;




